import Autosuggest from './Autosuggest';

export default Autosuggest;
